import { B as e, T as t, a as n, h as r, l as i, n as a, p as o, s, t as c, u as l } from "./useCollections-Vgy92T1D.js";
import { t as u } from "./sourceConversations-BdZZWFvt.js";
import { a as d, n as f, r as p, t as m } from "./useNotification-BENN0i41.js";
import { ApolloProvider as h, gql as g, useApolloClient as _ } from "@apollo/client";
import { Box as v, Button as y, Chip as b, DropdownButton as x, FieldSelect as S, FlexBox as C, Modal as w, ModalFoot as T, ModalHead as E, Text as D, Tooltip as O } from "@dixa/lib-shared-habla";
import { jsx as k, jsxs as A } from "react/jsx-runtime";
import { useMemo as j, useState as M } from "react";
import { ampli as N } from "lib-shared-tracking";
import { useHasAccess as P } from "lib-shared-access-control";
//#region ../management-common/src/components/categoryTreeInput/categoryDropdown.tsx
var F = ({ collectionId: e, value: t, onChange: n, onToggle: r, withCollectionOption: a, currentCategoryId: o, disabledCategoryIds: s = [], required: c, touched: l = !1, placeholder: u, label: f, className: p, disabled: m }) => {
	let [h, g] = M(!1), { data: _, loading: v } = i({
		variables: { collectionId: e },
		skip: !h
	}), y = (t) => {
		!e || !t || n(t === e ? {
			__typename: "Collection",
			id: e
		} : {
			__typename: "Category",
			id: t
		});
	}, { allDisabledCategoryIds: b, listItems: x } = d({
		categories: _?.collection?.categories || (t?.__typename === "Category" ? [t].filter(Boolean) : []),
		withCollectionOption: a,
		currentCategoryId: o,
		disabledCategoryIds: s,
		collectionId: e
	});
	return /* @__PURE__ */ k(S, {
		disabled: m || v,
		searchable: !0,
		className: p,
		label: f,
		noLabel: !f,
		required: c,
		onToggle: (e) => {
			g(e), r?.(e);
		},
		input: {
			name: "categoryDropdown",
			value: t?.id ? [t.id] : [],
			onChange: y
		},
		meta: {
			error: c && !t?.id ? "Category is required" : void 0,
			touched: l
		},
		disabledItems: b,
		items: v ? [] : x,
		placeholder: v ? "Loading Categories..." : u
	});
}, I = { categoryTreeInput: "_categoryTreeInput_1dov9_1" }, L = ({ value: e, onChange: t, withCollectionOption: n, currentCategoryId: r, disabledCategoryIds: i = [], collectionId: a, required: o, label: s = "Parent Category", placeholder: c, disabled: l }) => {
	let { cache: u } = _(), d = e?.__typename === "Category" ? u.readFragment({
		id: `Category:${e?.id}`,
		fragment: g`
            fragment CategoryTitles on Category {
              id
              titles {
                title
                languageId
              }
            }
          `
	}) : e;
	return a ? /* @__PURE__ */ k(F, {
		value: d,
		onChange: t,
		collectionId: a,
		className: I.categoryTreeInput,
		label: s,
		required: o,
		disabled: l,
		currentCategoryId: r,
		disabledCategoryIds: i,
		placeholder: c ?? (n ? "Select a parent" : "Select a parent category"),
		withCollectionOption: n
	}) : /* @__PURE__ */ k(S, {
		disabled: !0,
		searchable: !0,
		label: s,
		required: o,
		placeholder: c ?? "Select parent category",
		input: {
			name: e?.id || "Collection",
			value: e?.id || "collection",
			onChange: () => {}
		}
	});
};
//#endregion
//#region ../management-common/src/components/draftFiling.tsx
function R({ collections: e, collectionsLoading: t = !1, hasMoreCollections: n = !1, onLoadMoreCollections: r, collectionId: i, categoryId: a, onChange: o, isSaving: s = !1 }) {
	let c = t || s, l = a ? {
		__typename: "Category",
		id: a
	} : void 0;
	return /* @__PURE__ */ k(v, {
		width: "320px",
		padding: "300",
		background: "neutral.000",
		borderRadius: "100",
		children: /* @__PURE__ */ A(C, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ k(S, {
				label: "Collection",
				required: !0,
				disabled: c,
				placeholder: "Select a collection",
				input: {
					name: "draftFilingCollection",
					value: i ? [i] : [],
					onChange: (e) => {
						e && o({
							collectionId: e,
							categoryId: null
						});
					}
				},
				items: [...e],
				pagination: {
					infinite: !0,
					nextEnable: n,
					previousEnable: !1,
					onNext: r
				}
			}), /* @__PURE__ */ k(L, {
				value: l,
				onChange: (e) => o({ categoryId: e.id }),
				withCollectionOption: !1,
				currentCategoryId: void 0,
				collectionId: i || void 0,
				required: !0,
				disabled: c,
				label: "Category",
				placeholder: "Select a category"
			})]
		})
	});
}
var z = {
	modal: "_modal_1iu0t_54",
	body: "_body_1iu0t_60",
	scroll: "_scroll_1iu0t_66",
	articlePreview: "_articlePreview_1iu0t_73",
	modalHead: "_modalHead_1iu0t_79",
	footer: "_footer_1iu0t_83",
	newArticleChip: "_newArticleChip_1iu0t_89",
	visuallyHiddenTitle: "_visuallyHiddenTitle_1iu0t_94"
};
//#endregion
//#region src/components/Modals/useAiDraftEditor.tsx
function B({ initialDraft: r, conversationId: i }) {
	let { hideModal: o } = t(), { errorNotify: c } = m(), u = l(), [d, { loading: f }] = s({ client: u }), [p, { loading: h }] = n({
		client: u,
		refetchQueries: [a]
	}), g = P("knowledge.content:w"), [_, v] = M(r), [y, b] = M(""), x = "multiple-conversations";
	async function S(e, t) {
		try {
			let n = await d({ variables: {
				id: _.id,
				...e
			} });
			n.data?.aiDraftUpdate && (v(n.data.aiDraftUpdate), t?.());
		} catch (e) {
			c({ text: e?.message || "Something went wrong" });
		}
	}
	async function C(e) {
		e && (N.conversationArticleDraftImprovementRequested({
			conversationId: i,
			collectionId: _.collectionId || "",
			languageCode: _.languageId,
			draftSource: x
		}), await S({ feedback: e }, () => N.conversationArticleDraftImprovementResponseReceived({
			conversationId: i,
			collectionId: _.collectionId || "",
			languageCode: _.languageId,
			draftSource: x
		})));
	}
	async function w() {
		try {
			await p({ variables: { id: _.id } }), o();
		} catch (e) {
			c({ text: e?.message || "Something went wrong" });
		}
	}
	return {
		draft: _,
		improveInput: y,
		setImproveInput: b,
		onImproveDraft: C,
		onChangePlacement: S,
		onDiscardDraft: w,
		canDiscardDraft: g || !!_.initiatedBy && _.initiatedBy.id === e(),
		isGenerating: f,
		isDiscarding: h
	};
}
//#endregion
//#region src/components/Modals/multiConversationDraftModal.tsx
function V({ draft: e, conversationId: n }) {
	let { hideModal: a } = t(), { currentQueueId: s } = r(o), [m, g] = M(!1), _ = B({
		initialDraft: e,
		conversationId: n
	}), { draft: S } = _, N = l(), { data: P, loading: F } = c(), I = j(() => (P?.collections.results ?? []).filter((e) => e.linkedResources.some((e) => e.id === s) || e.id === S.collectionId).map((e) => ({
		id: e.id,
		name: e.title
	})), [
		P,
		s,
		S.collectionId
	]), L = j(() => I.find((e) => e.id === S.collectionId)?.name || "", [I, S.collectionId]), { data: V } = i({
		client: N,
		variables: { collectionId: S.collectionId || "" },
		skip: !S.collectionId
	}), H = [L, j(() => !S.collectionId || !S.categoryId ? "" : d({
		categories: V?.collection?.categories || [],
		collectionId: S.collectionId,
		withCollectionOption: !1,
		currentCategoryId: void 0,
		disabledCategoryIds: []
	}).listItems.find((e) => e.id === S.categoryId)?.name.trim() || "", [
		V,
		S.categoryId,
		S.collectionId
	])].filter(Boolean).join(" · "), U = j(() => Array.from(/* @__PURE__ */ new Set([n, ...S.referencedConversationIds])).map((e) => ({ csid: e })), [n, S.referencedConversationIds]), W = _.isGenerating || _.isDiscarding, G = /* @__PURE__ */ A(C, {
		flexDirection: "column",
		flex: "0 0 auto",
		gap: "200",
		margin: "0 500 300",
		padding: "300 400",
		background: "purple.100",
		borderWidth: "100",
		borderColor: "purple.300",
		borderRadius: "100",
		children: [
			/* @__PURE__ */ A(C, {
				justifyContent: "space-between",
				alignItems: "flex-start",
				gap: "200",
				children: [/* @__PURE__ */ k(b, {
					noBorder: !0,
					className: z.newArticleChip,
					children: "New article"
				}), /* @__PURE__ */ k(u, { conversations: U })]
			}),
			/* @__PURE__ */ k(D.Heading, {
				variant: "heading-1",
				children: S.title
			}),
			/* @__PURE__ */ A(D.Paragraph, {
				variant: "3",
				color: "secondary",
				children: ["Initiated by ", S.initiatedBy?.name || "AI"]
			}),
			/* @__PURE__ */ A(C, {
				alignItems: "center",
				gap: "100",
				children: [/* @__PURE__ */ k(D.Paragraph, {
					variant: "3",
					color: "secondary",
					children: H
				}), /* @__PURE__ */ k(x, {
					icon: "pen",
					noArrow: !0,
					fixed: !0,
					buttonProps: {
						variant: "tertiary",
						"aria-label": "Change where this draft is filed",
						disabled: W
					},
					show: m,
					onToggle: g,
					dropdown: /* @__PURE__ */ k(h, {
						client: N,
						children: /* @__PURE__ */ k(R, {
							collections: I,
							collectionsLoading: F,
							collectionId: S.collectionId,
							categoryId: S.categoryId,
							onChange: _.onChangePlacement,
							isSaving: W
						})
					})
				})]
			})
		]
	});
	return /* @__PURE__ */ A(w, {
		isOpen: !0,
		onClose: a,
		allowEscClose: !1,
		className: z.modal,
		children: [/* @__PURE__ */ k(E, {
			title: /* @__PURE__ */ k("span", {
				className: z.visuallyHiddenTitle,
				children: "Create draft article"
			}),
			onClose: a,
			className: z.modalHead
		}), /* @__PURE__ */ A(C, {
			flexDirection: "column",
			className: z.body,
			children: [/* @__PURE__ */ A(v, {
				flex: "1",
				minHeight: "0",
				className: z.scroll,
				children: [G, /* @__PURE__ */ k(p, {
					articleContent: S.htmlContent,
					className: z.articlePreview
				})]
			}), /* @__PURE__ */ A(T, {
				className: z.footer,
				children: [/* @__PURE__ */ k(f, {
					value: _.improveInput,
					onChange: _.setImproveInput,
					onSubmit: _.onImproveDraft,
					isGenerating: _.isGenerating,
					isSaving: _.isDiscarding
				}), /* @__PURE__ */ k(v, {
					padding: "400 500",
					children: /* @__PURE__ */ k(C, {
						justifyContent: "flex-end",
						children: /* @__PURE__ */ k(O, {
							content: "Only the agent who asked for this draft can delete it",
							disabled: _.canDiscardDraft,
							wrap: "div",
							children: /* @__PURE__ */ k(y, {
								variant: "secondary",
								onClick: _.onDiscardDraft,
								disabled: W || !_.canDiscardDraft,
								children: "Discard Draft"
							})
						})
					})
				})]
			})]
		})]
	});
}
//#endregion
export { V as MultiConversationDraftModal };

//# sourceMappingURL=multiConversationDraftModal-C1sRd39t.js.map